import { useTranslation } from "react-i18next";
import { MEITRE_PRO_URL } from "@core/config/constants";

/**
 * "powered by Meitre" attribution link to MEITRE_PRO_URL, opened in a new tab.
 * Callers own layout (wrapper element, visibility breakpoints, spacing).
 */
const PoweredByMeitre = () => {
  const { t } = useTranslation('common');

  return (
    <a
      href={MEITRE_PRO_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block rounded-sm px-1 -mx-1 py-3.5 -my-3.5 text-foreground/50 hover:underline underline-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      {t('POWERED_BY')}{' '}
      <span className="font-['Playfair_Display'] font-bold tracking-wide text-meitre">
        Meitre
      </span>
    </a>
  );
};

export default PoweredByMeitre;
